// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Lightbox-CloseButton-module--cls1--2FxTQ","cls2":"Lightbox-CloseButton-module--cls2--EThUn Lightbox-CloseButton-module--cls1--2FxTQ"};